import { AxiosResponse } from "axios";
import HttpService from "./interface/HttpService";
import { Category } from "../model/solar-product/category";

class CategoryService {
	private instance: HttpService;
	private controllerName: string = "category";

	constructor() {
		this.instance = new HttpService(this.controllerName);
	}

	public async get(): Promise<AxiosResponse<Array<Category>>> {
		return this.instance.get();
	}

	public async getById(id: string | undefined): Promise<AxiosResponse<Category>> {
		return this.instance.get(id);
	}
}

const categoryService = new CategoryService();

export default categoryService;
